/* selectMessage.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./selectMessage.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import Heading from '@atlaskit/heading';
import { Flex, Stack } from '@atlaskit/primitives/compiled';
var styles = {
  boxStyles: "_4t3ivbgk _otyrpxbi",
  stackStyles: "_ca0qu2gc _n3tdu2gc _19bvutpp _u5f3utpp"
};
var CustomSelectMessage = function CustomSelectMessage(_ref) {
  var icon = _ref.icon,
    message = _ref.message,
    testId = _ref.testId;
  return /*#__PURE__*/React.createElement(Stack, {
    xcss: styles.stackStyles,
    testId: testId,
    alignInline: "center"
  }, /*#__PURE__*/React.createElement(Flex, {
    xcss: styles.boxStyles,
    alignItems: "center",
    justifyContent: "center"
  }, icon), /*#__PURE__*/React.createElement(Heading, {
    size: "xsmall"
  }, /*#__PURE__*/React.createElement(FormattedMessage, message)));
};
export default CustomSelectMessage;